module.exports = __webpack_public_path__ + "img/quote-summary-icon.e75fc4a0.webp";